import { createSelector } from 'reselect';
import { RootState } from 'store/types';
import { splitToArray } from 'modules/utils/ArrayUtils';
import { GlobalSearchItem } from 'store/global/types';
import { Immunization } from '../types';

export const immunizationsSelector = (state: RootState) => state.immunizations.immunizations;

export const immunizationsLoadingSelector = createSelector(
  immunizationsSelector,
  immunizations => immunizations.loading
);

export const immunizationsDataSelector = createSelector(
  immunizationsSelector,
  immunizations => immunizations.data
);

export const immunizationsErrorSelector = createSelector(
  immunizationsSelector,
  immunizations => immunizations.error
);

export const immunizationsRequestStateSelector = createSelector(
  immunizationsSelector,
  immunizations => immunizations.requestState
);

// Utah State
export const usirSelector = (state: RootState) => state.immunizations.usir;

export const usirLoadingSelector = createSelector(usirSelector, usir => usir.usirLoading);

export const usirDataSelector = createSelector(usirSelector, usir => {
  return usir.data;
});

export const usirErrorSelector = createSelector(usirSelector, usir => usir.error);

export const hasUsirLoadingSelector = createSelector(usirSelector, usir => usir.hasUsirLoading);

export const hasUsirSelector = createSelector(usirSelector, usir => usir.hasUsir);

export const hasUsirErrorSelector = createSelector(usirSelector, usir => usir.hasUsirError);

export const shareUsirSendingSelector = (state: RootState) =>
  state.immunizations.shareUsir.isFetching;

/**
 * Share Immunizations
 */
export const shareImmunizationsSelector = (state: RootState) =>
  state.immunizations.shareImmunizations;

export const shareImmunizationsSendingSelector = createSelector(
  shareImmunizationsSelector,
  shareImmunizations => shareImmunizations.isSendingImmunizations
);

export const shareImmunizationsDataSelector = createSelector(
  shareImmunizationsSelector,
  shareImmunizations => shareImmunizations.sharedImmunizationsData
);

/**
 * Download Immunizations
 */
export const immunizationsDownloadsSelector = (state: RootState) =>
  state.immunizations.downloadImmunizations;

export const immunizationsDownloadingSelector = createSelector(
  immunizationsDownloadsSelector,
  downloadImmunizations => downloadImmunizations.isDownloading
);

export const immunizationsDownloadErrorSelector = createSelector(
  immunizationsDownloadsSelector,
  downloadImmunizations => downloadImmunizations.error
);

export const searchFormattedImmunizations = createSelector(immunizationsDataSelector, data => {
  return data.map(
    (item: Immunization): GlobalSearchItem => {
      const keywords = splitToArray(item?.immunizationName, ' ', [item?.immunizationSeries]);
      return {
        title: `Immunization - ${item?.immunizationName}`,
        date: item?.immunizationDate,
        keywords,
        navWebPath: '/u/health-record/immunizations',
        navParams: {},
        icon: 'MedicalHistoryIcon',
        category: 'Immunizations'
      };
    }
  );
});
